<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12">
        <v-container>
          <v-row>
            <v-spacer></v-spacer>
            <v-col>
              <v-autocomplete
                v-model="filtroPuesto"
                label="Filtrar por puesto"
                rounded
                filled
                dense
                hide-details
                color="secondary"
                background-color="transparent"
                class="filter-input"
                :items="puestos"
                item-value="catPuesto.puesto"
                item-text="catPuesto.puesto"
                item-color="secondary"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col>
              <v-text-field
                v-model="buscaPersonal"
                rounded
                filled
                dense
                hide-details
                background-color="transparent"
                color="secondary"
                label="Buscar personal"
                append-icon="mdi-magnify"
                class="search-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="headers"
                :items="filteredPersonal"
                class="primary ui-module-table"
                :loading="loading"
              >
                <template v-slot:[`item.nombre`]="{ item }">
                  <div class="d-inline-flex align-center pt-4">
                    <v-avatar size="48" class="mr-4">
                      <v-img :src="item.foto"></v-img>
                    </v-avatar>
                    <div>
                      <div class="text-caption font-weight-bold">
                        {{ getFullName(item) }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:[`item.puesto`]="{ item }">
                  {{ item.puesto }}
                </template>
                <template v-slot:[`item.vigenciaEvaluacionC3`]="{ item }">
                  <div
                    :class="
                      item.vigenciaEvaluacionC3 && !item.vigenciaEvaluacionC3.startsWith('1900-01-01')
                        ? 'success--text font-weight-bold'
                        : 'error--text font-weight-bold'
                    "
                  >
                    {{ formatearFecha(item.vigenciaEvaluacionC3) }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-overlay :value="overlay" :z-index="999" align="center" color="transparent" opacity="1">
      <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
      <!-- <div class="text-overline mt-4">Cargando información. Por favor, espere...</div> -->
    </v-overlay>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  async mounted() {
    this.loading = true
    if (this.personal.length == 0) {
      // await this.fetchPersonalPagination({
      //     page: this.options.page,
      //     rows: this.options.itemsPerPage,
      // })
      await this.fetchPersonalByDependencia(1)
    }
    await this.fetchPuestosByDependencia(1)
    this.loading = false
  },

  data() {
    return {
      loading: false,
      buscaPersonal: '',
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Puesto', value: 'puesto', sortable: false },
        { text: 'Vigencia C3', value: 'vigenciaEvaluacionC3', align: 'center', sortable: false },
      ],

      overlay: false,

      filtroPuesto: null,
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getFullPersonal',
    }),

    ...mapGetters('puesto', {
      puestos: 'getPuestos',
    }),

    filteredPersonal() {
      let resultado = this.personal

      if (this.filtroPuesto) {
        resultado = resultado.filter((item) => item.puesto === this.filtroPuesto)
      }

      if (this.buscaPersonal) {
        const busqueda = this.buscaPersonal.toLowerCase()
        resultado = resultado.filter((item) => {
          const nombre = this.getFullName(item).toLowerCase()
          return nombre.includes(busqueda)
        })
      }

      return resultado
    },
  },

  methods: {
    ...mapActions('personalLoc', ['savePersonalLoc']),
    ...mapActions('personal', ['fetchPersonalPagination', 'fetchPersonalByDependencia']),
    ...mapActions('puesto', ['fetchPuestosByDependencia']),

    async triggerSavePersonalLoc(idPersonal) {
      this.overlay = true

      await this.savePersonalLoc({
        idPersonal: idPersonal,
        fk_idLoc: 1,
      })
      this.overlay = false
    },

    getFullName(person) {
      if (!person) return ''
      if (!person.segundoNombre) {
        return `${person.apaterno} ${person.amaterno} ${person.nombre}`
      } else {
        return `${person.apaterno} ${person.amaterno} ${person.nombre} ${person.segundoNombre}`
      }
    },

    formatearFecha(fecha) {
      if (!fecha || fecha.startsWith('1900-01-01')) return 'No registrada'
      const [year, month, day] = fecha.split('-')
      return `${day}/${month}/${year}`
    },
  },
}
</script>

<style scoped>
::v-deep .search-input .v-input__slot,
::v-deep .filter-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover,
::v-deep .filter-input .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .search-input .v-input__control,
::v-deep .filter-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input.v-input--is-focused .v-input__control,
::v-deep .filter-input.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input input,
::v-deep .filter-input input {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-label,
::v-deep .filter-input .v-label,
::v-deep .filter-input .v-select__selection,
::v-deep .filter-input .mdi-menu-down,
::v-deep .search-input .mdi-magnify {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label,
::v-deep .filter-input.v-input--is-focused .v-label {
  color: #a29bfe !important;
}
</style>
